module.exports = __webpack_public_path__ + "assets/img/icon-4.fd2c0d1b.png";